var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-container"},[_c('el-card',{staticClass:"feature-card",staticStyle:{"width":"100%"}},[_c('h4',[_vm._v(_vm._s(_vm.name))]),_c('p',{staticStyle:{"font-size":"15px","color":"#474747"}},[_vm._v(_vm._s(_vm.detail))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }